export default {
  title: 'Set a new password',
  subtitle: 'Secure your account with a strong password',
  confirmButton: 'Confirm',
  placeholder: {
    newPassword: 'Enter a new password',
    repeatNewPassword: 'Repeat a new password',
  },
};
